module.exports = __webpack_public_path__ + "icon-framework-protractor.35K1EELN.svg";